import type { ReactNode } from 'react';

export const symbol_arrow_top_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m274-575 141 140q9 9 9 21.5t-8.6 21.62q-9.38 9.12-21.89 9.5Q381-382 372-391L181-582q-5-5-7-10.13-2-5.14-2-11 0-5.87 2-10.87 2-5 7-10l192-194q9.07-9 21.53-9 12.47 0 21.47 9 9 9 9 21t-9 21L275-635h425q24.75 0 42.38 17.62Q760-599.75 760-575v385q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-385H274Z"
		/>
	</svg>
);
